export const TABLE_STORAGE_KEY = 'table-redux-state';
